module.exports = __webpack_public_path__ + "static/img/ins.ee20679.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ins.png
// module id = mZP1
// module chunks = 10